// extracted by mini-css-extract-plugin
module.exports = {"root":"uni_profile_wrapper_root__RFJXJ","uni_breacrumbs":"uni_profile_wrapper_uni_breacrumbs__xF7gV"};